import React from 'react';
import { Typography } from 'antd';
import { FormikErrors } from 'formik';

import { useTheme } from '../../../hooks/useTheme';

const { Text } = Typography;

export const TextError = ({
    text,
}: {
    text: string | string[] | FormikErrors<any> | FormikErrors<any>[];
}) => {
    const { colorError } = useTheme();

    return <Text style={{ color: colorError }}>{text}</Text>;
};
